import React from 'react';
import CustomOrderSection from '../components/CustomOrderSection';

const CustomOrderPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <CustomOrderSection />
      </div>
    </div>
  );
};

export default CustomOrderPage;

